import { JsonProperty } from "@nstep-common/utils";


/** REQUESTS */

export class UserLoginModel {
	userName: string = '';
	password: string = '';

	twoFactorCode: string | null = null;
	email: string | null = null;
	trustDevice: boolean = false;

	constructor(data: Partial<UserLoginModel> | null = null) {
		if (data) {
			Object.assign(this, data);
		}
	}
}

export class ResetPasswordModel {
	userName!: string;
	oldPassword!: string;
	newPassword!: string;
	confirmPassword!: string;
	twoFactorCode: string | null = null;
	email: string | null = null;

	constructor(data: Partial<ResetPasswordModel> | null = null) {
		if (data) {
			Object.assign(this, data);
		}
	}
}


export class ImpersonateModel {

	@JsonProperty({ type: String })
	userName: string = '';

	constructor(data: Partial<ImpersonateModel> | null = null) {
		if (data) {
			Object.assign(this, data);
		}
	}
}

/** RESPONSES */

export class MobileAuthenticatorModel {
	@JsonProperty({ type: String, array: true })
	sharedKey!: string[];

	@JsonProperty({ type: String })
	authenticatorUri!: string;

	constructor(data: Partial<MobileAuthenticatorModel> | null = null) {
		if (data) {
			Object.assign(this, data);
		}
	}
}

export class AuthenticatorStatus {
	@JsonProperty({ type: Boolean })
	mobileEnabled!: boolean;

	@JsonProperty({ type: MobileAuthenticatorModel, nullable: true })
	mobile!: MobileAuthenticatorModel | null;

	@JsonProperty({ type: Boolean })
	emailEnabled!: boolean;

	@JsonProperty({ type: String, array: true })
	emails: string[] = [];

	constructor(data: Partial<AuthenticatorStatus> | null = null) {
		if (data) {
			Object.assign(this, data);
		}
	}
}

export class AccountModel {
	@JsonProperty({ type: String, nullable: true })
	accessToken!: string | null;

	@JsonProperty({ type: Boolean })
	requiresPasswordReset!: boolean;

	@JsonProperty({ type: Boolean })
	requiresTwoFactor!: boolean;

	@JsonProperty({ type: Boolean })
	requiresTwoFactorActivation!: boolean;

	@JsonProperty({ type: Number })
	requiresTwoFactorActivationDays!: number;

	@JsonProperty({ type: AuthenticatorStatus })
	authenticatorStatus!: AuthenticatorStatus;

	@JsonProperty({ type: Number })
	trustDeviceForDays!: number;

	constructor(data: Partial<AccountModel> | null = null) {
		if (data) {
			Object.assign(this, data);
		}
	}
}

export class RefreshTokensModel {
	@JsonProperty({ type: String })
	accessToken!: string;

	constructor(data: Partial<RefreshTokensModel> | null = null) {
		if (data) {
			Object.assign(this, data);
		}
	}
}

export class EnableMobileAuthenticatorModel {
	@JsonProperty({ type: String })
	code!: string;

	constructor(data: Partial<EnableMobileAuthenticatorModel> | null = null) {
		if (data) {
			Object.assign(this, data);
		}
	}
}

export class EnableEmailAuthenticatorModel {
	@JsonProperty({ type: String })
	email!: string;


	@JsonProperty({ type: String })
	twoFactorCode!: string;

	constructor(data: Partial<EnableEmailAuthenticatorModel> | null = null) {
		if (data) {
			Object.assign(this, data);
		}
	}
}

export class ResetEmailAuthenticator {
	@JsonProperty({ type: String })
	email!: string;

	constructor(data: Partial<ResetEmailAuthenticator> | null = null) {
		if (data) {
			Object.assign(this, data);
		}
	}
}